module.exports = __webpack_public_path__ + "static/img/02450_6.7d67213.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/02450_6.jpg
// module id = qHwi
// module chunks = 1